import type { ReactNode } from "react";
import { tw } from "../../styling";
import { Paper } from "../paper";

type ICard = {
	children: ReactNode;
	component?: "div" | "section" | "article";
	background?: "default" | "urgent" | "tertiary" | "success";
	plain?: boolean;
	classNames?: string;
};

export const Card = ({
	component = "article",
	children,
	background = "default",
	plain,
	classNames,
}: ICard) => {
	return (
		<Paper
			className={tw(
				"relative",
				background === "urgent" && "bg-background-alert",
				background === "tertiary" && "bg-background-tertiary",
				background === "default" && "bg-background-primary",
				background === "success" && "bg-background-success",
				classNames,
			)}
			component={component}
			plain={plain}
		>
			{children}
		</Paper>
	);
};
